module.exports = __webpack_public_path__ + "static/img/app_front_mobile.f21b09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/app_front_mobile.png
// module id = NDUT
// module chunks = 8